import Vue from "vue";
import Router from "vue-router";
//tabbar页
/***
 * 常用页
 * */
import home from "@/page/home/home";
import toDo from "@/page/home/toDo";
import mine from "@/page/home/mine";
import supplier from "@/page/home/supplier";
import source from "@/page/home/source";
import sourcePage from "@/page/home/source-page";
import order from "@/page/home/order";
import inforPublic from "@/page/home/infor-public";
import notice from "@/page/home/notice";
import bidding from "@/page/home//bidding";
import biddingDel from "@/page/home//biddingDel";
import general from "@/page/home/general";
import article from "@/page/home/article"; //文章详情页
import getArticle from "@/page/home/get-article"; //文章详情页(询价招标)
import comment from "@/page/home/comment"; //文章评论页
// 留言管理
import leaveMessageList from "@/page/leave-message/leave-message-list";
/**
 * 注册/登录页
 * */
//供应商注册页
import register from "@/page/supplier/register/register";
import phoneValid from "@/page/supplier/register/phone-valid";
import registerLogin from "@/page/supplier/register/register-login";
//登录页
import login from "@/page/user/login";
import resetPassword from "@/page/user/reset-password";
import sendEmailSuccess from "@/page/user/send-email-success";
import ddLogin from "@/page/user/dd-login"; //钉钉授权登录页
import personalInfo from "@/page/home/personal-info";
import feedback from "@/page/home/feedback";
import favorite from "@/page/home/favorite";
/**
 * 流程页面
 * */
import workflow from "@/page/flow/workflow";
import dynamicFlow from "@/page/flow/dynamic-flow";
import flowToDoList from "@/page/flow/flow-todo-list";
import flowDoneList from "@/page/flow/flow-done-list";
import flowEndList from "@/page/flow/flow-end";
import dynamicFormList from "@/page/dynamic-form-list/dynamic-form-list";
import dynamicFormDone from "@/page/dynamic-form-list/dynamic-form-done";
import contractReceiveList from "@/page/dynamic-form-list/contract-receive/contract-receive-list";
/*我的流程*/
import MyWorkflow from "@/page/workflow/my-workflow";
/*ERP信息维护*/
import ERPInfoModify from "@/page//dynamic-form-list/erp-info-modify/erp-info-modify-list";

import supplierRouter from "./supplier";
import sourceRouter from "./source";
import procureRouter from "./procure";
import driverRouter from "./driver";

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/home/to-do"
    },
    /**
     * 常用的功能
     */
    {
      path: "/home",
      component: home,
      children: [
        {
          path: "mine",
          name: "mine",
          component: mine,
          meta: {
            title: "我的"
          }
        },
        {
          path: "general",
          name: "general",
          component: general,
          meta: {
            title: "通用"
          }
        },
        {
          path: "to-do",
          name: "to-do",
          component: toDo,
          meta: {
            title: "待办"
          }
        },
        {
          path: "supplier",
          name: "supplier",
          component: supplier,
          meta: {
            title: "供应商"
          }
        },
        {
          path: "source-sup",
          name: "sources",
          component: source,
          meta: {
            title: "寻源"
          }
        },
        {
          path: "source",
          name: "source-page",
          component: sourcePage,
          meta: {
            title: "寻源"
          }
        },
        {
          path: "order",
          name: "order",
          component: order,
          meta: {
            title: "订单"
          }
        }
      ]
    },
    {
      path: "/personal-info",
      component: personalInfo,
      meta: { title: "个人详情" }
    },
    {
      path: "/feedback",
      component: feedback,
      meta: { title: "意见反馈" }
    },
    {
      path: "/favorite",
      component: favorite,
      meta: { title: "设置" }
    },
    {
      path: "/article/:id",
      component: article,
      meta: {
        title: "文章详情"
      }
    },
    {
      path: "/get-article/:id",
      component: getArticle,
      meta: {
        title: "询价招标详情"
      }
    },
    {
      path: "/article/:id/comment",
      component: comment,
      meta: {
        title: "评论"
      }
    },
    {
      path: "/infor-public",
      name: "infor-public",
      component: inforPublic,
      meta: {
        title: "信息公示"
      }
    },
    {
      path: "/notice",
      name: "notice",
      component: notice,
      meta: {
        title: "系统通知"
      }
    },
    {
      path: "/notice",
      name: "notice",
      component: notice,
      meta: {
        title: "系统通知"
      }
    },
    {
      path: "/bidding",
      name: "bidding",
      component: bidding,
      meta: {
        title: "询价招标公告"
      }
    },
    {
      path: "/biddingDel/:id",
      component: biddingDel,
      meta: {
        title: "询价招标公告详情"
      }
    },
    {
      path: "/leave-message-list",
      component: leaveMessageList,
      meta: {
        title: "留言列表"
      }
    },
    /**
     * 工作流
     */
    {
      path: "/workflow/:requestId",
      name: "workflow",
      component: workflow,
      meta: {
        title: "工作流程"
      }
    },
    {
      path: "/forward-workflow/:forwardId",
      name: "forward-workflow",
      component: workflow,
      meta: {
        title: "工作流程",
        type: "forward"
      }
    },
    {
      path: "/cc-workflow/:ccId",
      name: "cc-workflow",
      component: workflow,
      meta: {
        title: "工作流程",
        type: "cc"
      }
    },
    {
      path: "/monitor-workflow/:requestId",
      name: "monitor-workflow",
      component: workflow,
      meta: {
        title: "工作流程",
        type: "monitor"
      }
    },
    {
      path: "/supervision-workflow/:supervisionId",
      name: "supervision-workflow",
      component: workflow,
      meta: {
        title: "工作流程",
        type: "supervision"
      }
    },
    {
      path: "/single-workflow/:requestId",
      name: "single-workflow",
      component: workflow,
      meta: {
        title: "工作流程"
      }
    },
    {
      path: "/dynamic-flow",
      name: "dynamic-flow",
      component: dynamicFlow,
      meta: {
        title: "工作流程"
      }
    },
    {
      path: "/flow/todo",
      component: flowToDoList,
      meta: {
        title: "流程待办"
      }
    },
    {
      path: "/flow/done",
      component: flowDoneList,
      meta: {
        title: "流程已办"
      }
    },
    {
      path: "/flow/end",
      component: flowEndList,
      meta: {
        title: "流程办结"
      }
    },
    /**
     * 登录/注册
     */
    {
      path: "/user/login",
      component: login,
      meta: {
        title: "登录"
      }
    },
    {
      path: "/dd-login",
      name: "dd-login",
      component: ddLogin,
      meta: {
        title: "登录"
      }
    },
    {
      path: "/rest-password",
      component: resetPassword,
      meta: {
        title: "忘记密码"
      }
    },
    {
      path: "/send-email-success",
      component: sendEmailSuccess,
      meta: {
        title: "忘记密码"
      }
    },
    {
      path: "/supplier/register",
      component: register,
      meta: {
        title: "供应商注册"
      }
    },
    {
      path: "/supplier/phone-valid",
      component: phoneValid,
      meta: {
        title: "注册激活"
      }
    },
    {
      path: "/supplier/register-login/:checkKey",
      component: registerLogin,
      meta: {
        title: "新供应商注册"
      }
    },
    //动态表单列表
    {
      path: "/dynamic-form-list",
      name: "dynamic-form-list",
      component: dynamicFormList,
      meta: {
        title: "动态表单列表"
      }
    },
    //动态表单待办列表
    {
      path: "/dynamic-form-done",
      name: "dynamic-form-done",
      component: dynamicFormDone,
      meta: {
        title: "待办列表"
      }
    },
    //合同验收列表
    {
      path: "/contract-receive-list",
      name: "contract-receive-list",
      component: contractReceiveList,
      meta: {
        title: "合同验收列表"
      }
    },
    {
      path: "/my-workflow",
      name: "my-workflow",
      component: MyWorkflow,
      meta: {
        title: "我的流程"
      }
    },
    {
      path: "/erp-info-modify",
      name: "erp-info-modify",
      component: ERPInfoModify,
      meta: {
        title: "ERP信息维护"
      }
    },
    ...supplierRouter,
    ...sourceRouter,
    ...procureRouter,
    ...driverRouter,
    {
      path: "**",
      redirect: "/home/to-do"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js